import request from '@/utils/request'

let School_serviceApi = {

  /*校园服务列表*/
  list(data) {
    return request._post('/shop/plus.school_service.Index/index', data);
},
/*添加校园服务*/
add(data) {
    return request._post('/shop/plus.school_service.Index/add', data);
},
/*修改校园服务*/
edit(data) {
    return request._post('/shop/plus.school_service.Index/edit', data);
},
/*删除校园服务*/
del(data) {
    return request._post('/shop/plus.school_service.Index/del', data);
},
/*校园服务详情*/
detail(data) {
  return request._post('/shop/plus.school_service.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.school_service.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.school_service.Setting/getSetting', data, errorback);
    },
}
export default School_serviceApi;



// WEBPACK FOOTER //
// ./src/api/school_service.js